<form [formGroup]="searchForm">
  <app-card>
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'meteringPoint.search.meteringPointID' | translate }}</label>
          <input type="text" appInput formControlName="meteringPointIdentification" [placeholder]="'meteringPoint.search.meteringPointID' | translate" />
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.query.newmeteringpointwithsupplier.search.address' | translate }}</label>
          <input type="text" appInput formControlName="address" [placeholder]="'dashboard.query.newmeteringpointwithsupplier.search.address' | translate" />
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'meteringPoint.search.meteringPointType' | translate }}</label>
          <select appSelect formControlName="typeOfMeteringPoint" [collection]="meteringPointTypeOptions"></select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.query.newmeteringpointwithsupplier.search.datahubStatus' | translate }}</label>
          <select appSelect formControlName="dataHubStatus" [collection]="dataHubStatusOptions"></select>
        </app-input-group>
      </div>
    </div>
    <div class="flex gap-2">
      <button appButton (click)="performSearch()">{{ 'common.search' | translate }}</button>
      <button appButton type="tertiary" (click)="clearForm()">{{ 'common.reset' | translate }}</button>
    </div>
  </app-card>
</form>

<app-table
  #table
  [config]="tableConfig"
  [(selectedElements)]="selectedElements"
></app-table>
